export const XinTool = {
    arrayDelByItem<T>(arr: Array<T>,id:T): T[]{
        let newArr: T[] = [...arr]

        for(let i=0;i<newArr.length;i++){
            if(newArr[i]===id) { newArr.splice(i,1) }
        }

        return newArr
    },

    toZero(num:number): number|string{
        return num<=9 ? '0'+num : num
    }
}